module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/search/banner-da74270ca45bdde3e8568149b76fc273.webp";